import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "card-view-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 2.25C3.48079 2.25 2.25 3.48079 2.25 5V7.75C2.25 9.26921 3.48079 10.5 5 10.5H7.75C9.26921 10.5 10.5 9.26921 10.5 7.75V5C10.5 3.48079 9.26921 2.25 7.75 2.25H5ZM3.75 5C3.75 4.30921 4.30921 3.75 5 3.75H7.75C8.44079 3.75 9 4.30921 9 5V7.75C9 8.44079 8.44079 9 7.75 9H5C4.30921 9 3.75 8.44079 3.75 7.75V5Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.25 2.25C14.7308 2.25 13.5 3.48079 13.5 5V7.75C13.5 9.26921 14.7308 10.5 16.25 10.5H19C20.5192 10.5 21.75 9.26921 21.75 7.75V5C21.75 3.48079 20.5192 2.25 19 2.25H16.25ZM15 5C15 4.30921 15.5592 3.75 16.25 3.75H19C19.6908 3.75 20.25 4.30921 20.25 5V7.75C20.25 8.44079 19.6908 9 19 9H16.25C15.5592 9 15 8.44079 15 7.75V5Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 16.25C2.25 14.7308 3.48079 13.5 5 13.5H7.75C9.26921 13.5 10.5 14.7308 10.5 16.25V19C10.5 20.5192 9.26921 21.75 7.75 21.75H5C3.48079 21.75 2.25 20.5192 2.25 19V16.25ZM5 15C4.30921 15 3.75 15.5592 3.75 16.25V19C3.75 19.6908 4.30921 20.25 5 20.25H7.75C8.44079 20.25 9 19.6908 9 19V16.25C9 15.5592 8.44079 15 7.75 15H5Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.25 13.5C14.7308 13.5 13.5 14.7308 13.5 16.25V19C13.5 20.5192 14.7308 21.75 16.25 21.75H19C20.5192 21.75 21.75 20.5192 21.75 19V16.25C21.75 14.7308 20.5192 13.5 19 13.5H16.25ZM15 16.25C15 15.5592 15.5592 15 16.25 15H19C19.6908 15 20.25 15.5592 20.25 16.25V19C20.25 19.6908 19.6908 20.25 19 20.25H16.25C15.5592 20.25 15 19.6908 15 19V16.25Z"
    }, null, -1)
  ])))
}
export default { render: render }